import type { Epic } from 'Flux/index.js'
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { filter, of } from 'rxjs'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { addMessage } from 'Flux/Slice/Application/ApplicationSlice.js'
import { errorMessage } from 'Model/Message/IMessage.js'
import { explainPlatformOverrideRefusal } from 'Util/sequencingPlatform.js'
import { describeOrderWriteRefusal, isOrderVersionConflict, ORDER_VERSION_CONFLICT_MESSAGE } from '../orderWriteRefusal.js'

export const OverrideSequencingPlatformEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.overrideSequencingPlatformRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const current = state.order.order
      return OrderRepository.overrideSequencingPlatform(action.payload).pipe(
        map((response) => order.overrideSequencingPlatformSuccess(response)),
        catchError((error) =>
          of(
            order.overrideSequencingPlatformFailure({ error }),
            addMessage(
              errorMessage(
                (isOrderVersionConflict(error) && ORDER_VERSION_CONFLICT_MESSAGE) ||
                  describeOrderWriteRefusal(error) ||
                  (current && current !== 'LOADING' && explainPlatformOverrideRefusal(current, action.payload.platform)) ||
                  'Changing the sequencing platform failed.'
              )
            )
          )
        )
      )
    })
  )
